module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./SpecialView.js"));
	}, "SpecialView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=SpecialView!./src/pages/Shop/Home/Special/SpecialView.js
// module id = 1827
// module chunks = 367